/**
 * Gradient scroll behavior: when the logo carousel is 20% from the top,
 * the gradient ::after opacity follows scroll (decrease on scroll down, increase on scroll up).
 */
( function () {
  'use strict';

  let wrapper = document.querySelector( '.e-div--bg-gradient' );
  let logoSection = wrapper ? wrapper.querySelector( '.e-stn--logo-carousel' ) : null;

  if ( !wrapper || !logoSection ) return;

  let triggerRatio = 0.05; // Start effect when logo section top is at 5% of viewport from top
  let minOpacity = 0;
  let maxOpacity = 1;

  function setGradientOpacity() {
    let rect = logoSection.getBoundingClientRect();
    let vh = window.innerHeight;
    let triggerY = vh * triggerRatio;

    // Section top above trigger (scrolled up) → reduce opacity
    // Section top below trigger → full opacity
    if ( rect.top > triggerY ) {
      wrapper.style.setProperty( '--gradient-overlay-opacity', String( maxOpacity ) );
      return;
    }

    // Map: when rect.top === triggerY → 1; when rect.bottom <= 0 (section fully above) → 0
    let sectionHeight = rect.height;
    let rangeStart = triggerY;
    let rangeEnd = -sectionHeight;
    let current = rect.top;
    let t = ( current - rangeEnd ) / ( rangeStart - rangeEnd );
    t = Math.max( 0, Math.min( 1, t ) );
    let opacity = minOpacity + t * ( maxOpacity - minOpacity );
    wrapper.style.setProperty( '--gradient-overlay-opacity', String( opacity ) );
  }

  function onScroll() {
    requestAnimationFrame( setGradientOpacity );
  }

  window.addEventListener( 'scroll', onScroll, { passive: true } );
  window.addEventListener( 'resize', onScroll );
  setGradientOpacity();
} )();
